import React from "react";
import BackButton from "../bars/BackButton";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState, Fragment } from "react";
import ReactSearchBox from "react-search-box";
import { Switch } from "@headlessui/react";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  increaseCount,
  decreaseCount,
  clearCart,
} from "../../slices/CounterSlice.js";
import ViewOrder from "./ViewOrder.js";
import PlaceOrder from "./PlaceOrder.js";
import FoodCustomAlert from "./FoodCustomAlert.js";
import RedirectModal from "../../components/RedirectModal.js";
import Skeleton from "../../components/skeletons/skeleton.js";
import { CurrencySymbol, handleOffers } from "../../utils/util.js";
import Load from '../../images/Loadingimage.jpg';
import Broken from '../../images/broken.jpg';
import { InRoomFoodMenuPageView } from "../../utils/Analytics.js";
function FoodItems() {
  const location = useLocation();
  const hotelData = location.state;
  const [enabled, setEnabled] = useState(false);
  const [items, SetItems] = useState([]);
  const navigate = useNavigate();
  const [filteredFoodItems, SetFilteredFoodItems] = useState(items);
  const [IsLoading, SetLoading] = useState(true);
  let [isOpen, setIsOpen] = useState(false);
  let [isavailable, setAvailable] = useState(false);
  const currentUrl = window.location.href;
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const urlArray = currentUrl.split("/");
  console.log(urlArray)
  const HotelIdRestaurantId = urlArray[urlArray.length - 1];
  const IdArray = HotelIdRestaurantId.split("-");
  const hotelId = IdArray[0];
  const restaurantId = IdArray[1];
  const foodId =currentUrl.split('ItemId-')[1]

  const [resId, SetResId] = useState(restaurantId);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [foodItemsStored, setFoodItemsStore] = useState([]);
  const [isKitchenOpen, SetIsKitchenOpen] = useState(1);
  const totalAmount = useSelector((store) => store.counter.totalAmount);
  const foodCart = useSelector((store) => store.counter.cart);
  const dispatch = useDispatch();
  const [showPlaceOrder, setShowPlaceOrder] = useState(false);
  const [msgType, SetMsgType] = useState("success");
  const [showAlert, SetShowAlert] = useState(false);
  const isCheckedIn = localStorage.getItem("isCheckedIn");
  const [showRedirect, setShowRedirect] = useState(false);
  const [AllSelect ,setAllSelect] = useState(true);
 console.log("foodCart=======================",foodCart)
  useEffect(() => {
    InRoomFoodMenuPageView();
    // console.log(hotelData);
    if (hotelData == null) {
      navigate("../home");
    } else {
      console.log(hotelData)
      SetIsKitchenOpen(hotelData.open_kitchen);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("restaurantId", restaurantId);
    SetResId(restaurantId);
    const updatedItems = addingCountToList(foodCart, items);
    const oldUpdatedItems = addingCountToList(foodCart, foodItemsStored);
    SetItems(updatedItems);
    setFoodItemsStore(oldUpdatedItems);
    // console.log(foodCart, totalAmount);
  }, [foodCart]);

  const addingCountToList = (cart, totalList) => {
    const originalItems = totalList;
    const updatedItems = originalItems.map((item) => {
      const cartItem = cart.find((cartItem) => cartItem.id === item.id);
      const count = cartItem ? cartItem.count : 0;

      return { ...item, count };
    });

    return updatedItems;
  };

  useEffect(() => {
    console.log(location == null);
    // if (localStorage.getItem("phone_no") == null) {
    //     navigate("../");
    // }

    const getFood = async () => {
      console.log(hotelId, restaurantId)
      SetLoading(true);
      try {
        await axios({
          method: "post",
          url: `${baseURL}/api/restaurantMenuV2`,
          data: {
            hotelId: hotelId,
            restaurantId: restaurantId,
            sortBy: "restaurant",
          },
          headers: { "Content-Type": "multipart/form-data" },
        }).then(function (response) {
          if (response.data.data.length == 0) {
            setAvailable(true);
          }
           if (response.data.data[0].items.length != 0) {
          if(foodId){
            console.log(foodId,"ll")
          //   const reorderedItems = [
          //     ...response.data.data[0].items.filter(item => item.id == parseInt(foodId)),
          //     ...response.data.data[0].items.filter(item => item.id.parseInt != parseInt(foodId))
          // ];
          // console.log(reorderedItems)
          //      const updatedItems = addingCountToList(
          //       foodCart,
          //       reorderedItems
          //     );
          //     SetItems(updatedItems);
          console.log(response.data.data[0].items)

            const reorderedItems = [
              ...response.data.data[0].items.filter(item => parseInt(item.id) === parseInt(foodId)),
              ...response.data.data[0].items.filter(item => parseInt(item.id) !== parseInt(foodId))  // Corrected this line
            ];
            
            console.log(reorderedItems);
            
            const updatedItems = addingCountToList(foodCart, reorderedItems);
            SetItems(updatedItems);

          }else{
            console.log("sd","ll")
               const updatedItems = addingCountToList(
                foodCart,
                response.data.data[0].items
              );
              SetItems(updatedItems);
          }
         
          }
          setFoodItemsStore(response.data.data[0].items);
          setUniqueCategories(
            Array.from(
              new Set(response.data.data[0].items.map((item) => item.category))
            )
          );
        });
      } catch (e) {
        SetLoading(false);
      }
      SetLoading(false);
    };
    getFood();
  }, []);

  const toggleVeg = () => {
    setEnabled(!enabled);

    if (enabled == false) {
      SetItems(items.filter((item) => item.foodType == "Veg"));
    } else {
      SetItems(foodItemsStored);
    }
  };

  const filterCategory = (data) => {
    setAllSelect(false);
    setSelectedCategory(data);
    SetItems(foodItemsStored.filter((item) => item.category == data));
    if (enabled) {
      SetItems(foodItemsStored.filter((item) => item.category == data));
    }
  };

  const selectAll = () =>{
    setAllSelect(true);
    setSelectedCategory(null);
    SetItems(foodItemsStored);
  }
  const cloceAllSelect = () =>{
    setAllSelect(false);
    setSelectedCategory(null);
    SetItems(foodItemsStored);
  }

  const closeClick = () => {
    setAllSelect(true);
    setSelectedCategory(null);
    SetItems(foodItemsStored);
  };

  const showMsgBody = (param) => {
    SetMsgType(param);
    SetShowAlert(true);
    setTimeout(() => {
      SetShowAlert(false);
    }, 2000);
  };

  const handleDecrement = (param) => {
    // if (isCheckedIn == "true") {
    //   dispatch(decreaseCount(param));
    // } else {
    //   console.log("no checked in");
    //   setShowRedirect(true);
    // }
    console.log(param)
    dispatch(decreaseCount(param));
  };

  const handleIncrement = (param) => {
    // if (isCheckedIn == "true") {
    //   dispatch(increaseCount(param));
    // } else {
    //   setShowRedirect(true);
    // }
    dispatch(increaseCount(param));

  };

  // currency setup
const currencySymbol = CurrencySymbol();
  return (
    <div>
      {!IsLoading ? (
        <div>
          <div className="section-wrap mx-4 py-4">
            <div className="flex   space-x-3">
              <BackButton />
              <div className="guestName whitespace-nowrap flex items-center sm:text-center text-left">
                <div>Indoor Dining - </div>
                <div className="w-2/4 max-w-[210px] ml-3 truncate  ">
                  {hotelData.restaurant_name}
                </div>
              </div>
            </div>
            {/* <div className='mt-7 mb-[30px]'>
                    <ReactSearchBox
                        placeholder="Search Food" />
                </div> */}
          </div>
          <div className="bg-[#FAFAFA] pt-5 restaurant">
            <div className="section-wrap min-h-screen h-full relative">
              <div className="flex flex-row  w-full items-center">
                <div className="h-full flex items-start">
                  <div className="flex items-center">
                    {/* <div className="text-[#7E7E7E] font-semibold relative top-[1px] text-[8px] lg:text-[10px] whitespace-nowrap">
                      VEG ONLY{" "}
                    </div> */}
                    {/* <Switch
                      checked={enabled}
                      onChange={toggleVeg}
                      className={`${enabled ? "bg-green-700" : "bg-[#D3D3D3]"
                        } relative inline-flex h-[24px] w-[55px] ml-2 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${enabled ? "translate-x-[32px]" : "translate-x-0"
                          } pointer-events-none inline-block relative bottom-[-1px] h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                      {enabled ? null : (
                        <div className="relative text-[10px] font-semibold  text-white bottom-[-3px] right-[-4px]">
                          OFF
                        </div>
                      )}
                    </Switch> */}
                  </div>
                </div>
                {/* <div className="w-[1px] rounded bg-[#7E7E7E] relative top-1 h-[20px] shrink-0"></div> */}
                <div className="flex flex-row gap-2 md:w-auto w-[100%] h-fit overflow-x-auto foodcata scrollbar-hide  pb-1.5">
                  {uniqueCategories.length === 0 ? "" : 
                <div className="relative">
                <button
                        className={
                          AllSelect === false
                            ? "type-btn"
                            : "type-all-btn-active"
                        }
                        onClick={selectAll}
                      >All</button>
                     
                      </div>
                       }
                  {uniqueCategories.map((category, index) => (
                    <div className="relative">
                       
                      <button
                        key={index}
                        className={
                          (selectedCategory !== category) == true
                            ? "type-btn"
                            : "type-btn-active"
                        }
                        onClick={() => filterCategory(category)}
                      >
                      <span className=" w-[auto] max-w-[100px] truncate">
                        {category}
                        </span>  
                      </button>
                      <div
                        onClick={closeClick}
                        className={
                          !(selectedCategory !== category) == true
                            ? "ml-2 w-fit absolute right-3 left-13 bottom-[11px] z-10 text-[#3d38af] text-xs cursor-pointer"
                            : "hidden"
                        }
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_74_2965)">
                            <circle
                              cx="7.5"
                              cy="7.5"
                              r="6.25"
                              stroke="#8E724B"
                            />
                            <path
                              d="M9.06249 5.93751L5.9375 9.0625M5.93749 5.9375L9.06247 9.06249"
                              stroke="#8E724B"
                              stroke-linecap="round"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_74_2965">
                              <rect width="15" height="15" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="flex items-center mt-5">
                    <div className="text-[#7E7E7E] font-semibold relative top-[1px] text-[8px] lg:text-[10px] whitespace-nowrap">
                      VEG ONLY{" "}
                    </div>
                    <Switch
                      checked={enabled}
                      onChange={toggleVeg}
                      className={`${enabled ? "bg-green-700" : "bg-[#D3D3D3]"
                        } relative inline-flex h-[24px] w-[55px] ml-2 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                    >
                      <span
                        aria-hidden="true"
                        className={`${enabled ? "translate-x-[32px]" : "translate-x-0"
                          } pointer-events-none inline-block relative bottom-[-1px] h-[18px] w-[18px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                      />
                      {enabled ? null : (
                        <div className="relative text-[10px] font-semibold  text-white bottom-[-3px] right-[-4px]">
                          OFF
                        </div>
                      )}
                    </Switch>
                  </div>
              {!isKitchenOpen && (
                <div className="unavailble-info mt-5">
                  {hotelData.restaurant_name} is currently closed at this
                  moment.
                </div>
              )}

              <div>
                <div>
                  <div className="mt-4 mb-4 pb-20">
                    {items.length === 0 ? (
                      <div className="flex items-center justify-center w-full h-[200px] text-center ">
                        <p className="text-gray-500 text-lg">No food items available. Please check back later!</p>
                      </div>
                    ) : (
                      <div className={`grid grid-flow-row sm:grid-cols-2 grid-cols-1 gap-4 gap-x-4 ${isKitchenOpen !== 1 ? "restarant-unavialble" : " "}`}>
                        {items.map((item, index) => (
                          <div
                            key={index}
                            className={`flex sm:flex-col flex-row sm:p-3 p-2 max-sm:h-[98px] h-[314px] rounded-md ${item.availability === 0 ? 'bg-[#ffffff]': 'bg-[#fff]'}   border border-[#EFEFEF] hover:shadow-md lg:shadow-none shadow transition-all relative`}
                          >
                            <div className="flex bg-[#eae5e5] justify-center items-center sm:h-[200px] sm:w-full w-[90px] h-[80px] rounded-md overflow-hidden cursor-pointer relative">
                            {(item.image.includes(".jfif") ) ?
                              <img
                                className= "object-cover w-full h-full"
                                src={
                                  item.image
                                }
                              
                                // onError={(e) => {
                                //   e.target.onerror = null; // Prevent infinite loop in case the fallback also fails
                                //   e.target.src = {Load}; // Provide your empty state image here
                                // }}
                              ></img>
                             :  <div
                             className=" w-full h-full"
                             style={{
                               backgroundImage: `url(${item.image})`,
                               backgroundSize: 'cover', 
                               backgroundPosition: 'center', 
                               backgroundRepeat: 'no-repeat', 
                               backgroundColor :"#dfe3e8",
                               filter: item.availability === 0 ? "grayscale(100%)" : "none",
                             }}>
                               </div>}
                               { item.availability === 0 && <div className="absolute top-50% border py-1 px-2 rounded-[8px] font-[500] bg-[white]  text-[red] text-[8px] text-center  sm:text-[14px]">Currently Unavailable</div>}
                            </div>
                            <div className="relative px-4 sm:px-0 sm:pl-0 flex flex-col justify-center w-full">
                              <div className="flex flex-wrap w-full text-base justify-between space-x-6 sm:space-x-0 items-center sm:mt-4 relative">
                                <div className="flex-col flex gap-1.5  max-sm:h-[65px] max-sm:mt-3.5  ">
                                  <div
                                    className="sm:text-left font-medium text-[#444444] sm:text-base text-sm text-left truncate w-[200px] sm:w-[200px] relative sm:top-0 -top-2"
                                    title={item.item_name}
                                  >
                                    {item.item_name}
                                  </div>
                                  <div className="text-[#676767] font-semibold text-sm relative sm:top-0 -top-2">
                                    {item?.discount ? (
                                      <div className=" flex flex-col item-center gap-0.5 w-[100%]  ">
                                        <div className="line-through w-[45px] block  text-[10px]" style={{ color: "#a69e9e" }}>{currencySymbol}{item?.price}</div>
                                        <div className="w-[55px] ">{currencySymbol}{parseFloat(handleOffers(parseFloat(item?.price), parseInt(item?.discount) || 0))?.toFixed(2) || '0.00'}</div>
                                      </div>
                                    ) : (
                                      <div className="w-[65px] "><span>{currencySymbol}</span><span>{parseFloat(item?.price)?.toFixed(2)}</span></div>
                                    )}
                                  </div>
                                </div>
                                {isKitchenOpen === 1 && (
                                  <div className="flex items-center justify-between mt-3 ">
                                    {item.count !== 0 && item.count ? (
                                      <div className="flex items-center gap-4 foodAddBtn absolute right-0 top-8">
                                        <button className="px-1" onClick={() => handleDecrement({ id: item.id, foodList: items })}>
                                          -
                                        </button>
                                        <div>{item.count}</div>
                                       <button className="px-1"  onClick={() => item.availability === 1 && handleIncrement({ id: item.id, foodList: items })}>
                                          +
                                        </button> 
                                      </div>
                                    ) : (item.availability === 1 && 
                                      <button
                                        className="foodAddBtn absolute right-0 top-8"
                                        onClick={() => handleIncrement({ id: item.id, foodList: items })}
                                      >
                                        Add +
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {foodCart.length != 0 && isKitchenOpen == 1 && (
                <ViewOrder
                currencySymbol={currencySymbol}
                  restaurantId={resId}
                  itemlength={foodCart.length}
                  totalAmount={totalAmount}
                  handleViewOrder={() => {
                    setShowPlaceOrder(true);
                  }}
                />
              )}

              {showPlaceOrder && (
                <PlaceOrder
                  currencySymbol={currencySymbol}
                  totalFoodList={items}
                  restaurantId={resId}
                  promotionId={hotelData?.promotionId}
                  showMsg={showMsgBody}
                  SetMsg={(msgData) => {
                    SetMsgType(msgData);
                  }}
                  closePlaceOrder={() => setShowPlaceOrder(false)}
                />
              )}

              {showAlert && (
                <FoodCustomAlert
                  msgtype={msgType}
                  hide={() => SetShowAlert(false)}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <Skeleton type="page" />
      )}
      {showRedirect && (
        <RedirectModal innerPage hideModal={() => setShowRedirect(false)} />
      )}
    </div>
  );
}

export default FoodItems;
